import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { RoleService } from 'src/app/core/services/role.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';

@Component({
  selector: 'filter-log',
  templateUrl: './filter-log.component.html',
  styleUrls: ['./filter-log.component.scss'],
})
export class FilterLogComponent implements OnInit {
  @Input() open;
  @Input() users;
  @Output() count = new EventEmitter();
  // public riskLevels = riskLevels;
  date = new Date();

  states = [
    {
      value: 'initial',
      name: 'Sin comenzar',
    },
    {
      value: 'running',
      name: 'En ejecución',
    },
    {
      value: 'tobeApproved',
      name: 'Por aprobar',
    },
    { value: 'archived', name: 'Archivado' },
    {
      value: 'toFinalize',
      name: 'Por finalizar',
    },
  ];
  today = { beging: new Date(), end: new Date() };
  yesterday = {
    beging: new Date(new Date().setDate(new Date().getDate() - 1)),
    end: new Date(),
  };
  last7Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 7)),
    end: new Date(),
  };
  last30Days = {
    beging: new Date(new Date().setDate(new Date().getDate() - 30)),
    end: new Date(),
  };
  dates = // ['Hoy', 'Ayer', 'Últimos 7 días', 'Últimos 30 días'];
    [
      {
        value: this.today,
        name: 'Hoy',
      },
      {
        value: this.yesterday,
        name: 'Ayer',
      },
      {
        value: this.last7Days,
        name: 'Últimos 7 días',
      },
      {
        value: this.last30Days,
        name: 'Últimos 30 días',
      },
    ];
  unitId;
  constructor(
    private readonly fb: FormBuilder,
    private readonly unitsService: UnitsService,
    private readonly route: ActivatedRoute, // private readonly casesService: CasesService
    private readonly userService: UserService,
    private readonly roleService: RoleService,
    private readonly casesService: CasesService
  ) {
    this.unitId = this.route.snapshot.paramMap.get('id');
  }
  form: FormGroup = this.fb.group({
    ip: [''],
    user: [''],
    role: [''],
    // unit: [''],
    // case_type: [''],
    // status: [''],
    // gai: [''],
    action: [''],
    start: [''],
    end: [''],
  });
  units = [];
  ngOnInit() {
    this.unitsService.getAllData(this.userService.currentUser).subscribe({
      next: (data) => {
        this.units = data;
        this.getRoles();
      },
    });
  }

  actions = [
    { value: 'CreateCase', key: 'Creación de un caso' },
    { value: 'EditCase', key: 'Edición de un caso' },
    { value: 'DeleteCase', key: 'Eliminación de un caso' },
    { value: 'Create User', key: 'Creación de un Usuario' },
    { value: 'Update User', key: 'Actualización de un Usuario' },
    { value: 'Delete User', key: 'Eliminación de un Usuario' },
    { value: 'Blocked User', key: 'Bloqueo de un Usuario' },
    {
      value: 'Update Password User',
      key: 'Actualización de password de un Usuario',
    },
    { value: 'CreateRole', key: 'Creación de un Rol' },
    { value: 'UpdateRole', key: 'Actualización de un Rol' },
    { value: 'DeleteRole', key: 'Eliminación de un Rol' },
    { value: 'CreateUnit', key: 'Creación de una Unidad' },
    { value: 'UpdateUnit', key: 'Actualización de una Unidad' },
    { value: 'DeleteUnit', key: 'Eliminación de una Unidad' },
    { value: 'CreateCaseType', key: 'Creación de un Tipo de Caso' },
    { value: 'UpdateCaseType', key: 'Actualización de un Tipo de Caso' },
    { value: 'DeleteCaseType', key: 'Eliminación de un Tipo de Caso' },
    { value: 'CreateTask', key: 'Creación de una Tarea' },
    { value: 'UpdateTask', key: 'Actualización de una Tarea' },
    { value: 'DeleteTask', key: 'Eliminación de una Tarea' },
    { value: 'Login', key: 'Ingreso al sistema' },
    { value: 'LogOut', key: 'Salio del sistema' },
    { value: 'AssistantToolExecuted', key: 'Asistente IA: acción ejecutada' },
    { value: 'AssistantToolFailed', key: 'Asistente IA: acción fallida' },
  ];
  get getUnits() {
    return this.units.map((x) => x.unit);
  }

  unitsSelected = [];
  get caseTypes() {
    let caseTypes: ICaseType[] = [];
    let data = this.units.find((x) => x.unit._id == this.form.value.unit);
    if (data) caseTypes = [...caseTypes, ...data.cases];
    return caseTypes;
  }
  roles;
  getRoles() {
    this.roleService.getAll().subscribe((roles) => {
      this.roles = roles;
    });
  }
  // removeCasesByUnit() {
  //   this.form.value.unit = this.form.value.unit.filter((caseSelected) => {
  //     if (this.caseTypes.find((x) => x._id == caseSelected)) {
  //       return caseSelected;
  //     }
  //   });
  // }
  search() {
    this.casesService.filterRecord.next(this.form.value);
    let count = 0;
    for (let key in this.form.value) {
      if (
        this.form.value[key] != '' ||
        this.form.value[key] != 'null' ||
        this.form.value[key] != null
      ) {
        count += 1;
      }
    }
    this.count.emit(count);
  }
  cleanFilter() {
    this.form.reset();

    this.count.emit(0);
    this.casesService.filterRecord.next(this.form.value);
  }
}
